import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { TransporterImportModel } from 'src/app/models/imports/transporter-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { TransporterService } from 'src/app/services/archive/transporter.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-transporter',
  templateUrl: './import-transporter.component.html',
  styleUrls: ['./import-transporter.component.scss'],
  standalone: false
})
export class ImportTransporterComponent {

  errorTransporter: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  transporterImport: boolean = false;
  transporterAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  visibleTxt: boolean = false;

  constructor(
    private transporterService: TransporterService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.transporterImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.transporterService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaTransportadores.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.transporterAlerts || this.transporterAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.transporterService.exportImportErrors(this.transporterAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionTransportadores_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  importTransporters() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<TransporterImportModel>();
    let row: TransporterImportModel;
    let counter: number = 1, branchCode: number, name: string, typeDocumentId: number, documents: string, digitVerification: number,
      phone: string, alterPhone: string | null, active: boolean, swExternal: boolean;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'warning',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }
      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código de la sucursal no es válido.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }

        //B. Nombre Transportador:
        name = element[1] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El nombre del Transportador no es válido.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 75) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El nombre del Transportador supera el tamaño máximo de caracteres (75)`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }

        //C. Tipo Documento:
        const valueTypeDocumentId = element[2];
        if (valueTypeDocumentId == null || valueTypeDocumentId === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código del tipo de documento no es válido.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }
        typeDocumentId = Number(valueTypeDocumentId);
        if (isNaN(typeDocumentId)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código del tipo de documento no es válido.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }

        //D. Documento:
        documents = element[3] as string;
        if (documents == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El numero de documento no es válido.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        } else if (documents.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El numero de documento: supera el tamaño máximo de caracteres (15)`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }

        //E. Dígito de Verificación
        const valueDigitVerification = element[4];
        if (valueDigitVerification == null || valueDigitVerification === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El dígito de verificación no es válido.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }
        digitVerification = Number(valueDigitVerification);
        if (isNaN(digitVerification)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El dígito de verificación no es válido.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }

        //F. Número Telefono:
        phone = element[5] as string;
        if (phone == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El número telefono no es válido`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        } else if (phone.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El número telefono: supera el tamaño máximo de caracteres (15)`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }

        //G. Segundo Número Telefono:
        alterPhone = element[6] as string;
        if (alterPhone != null) {
          if (alterPhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna G. El número telefono alterno: supera el tamaño máximo de caracteres (15)`;
            this.transporterAlerts.push(alert);
            rowHasError = true;
          }
        }

        // H. Activo:
        if (element[7] as string != "S" && element[7] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. El campo Activo debe ser valores como: S / N.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }
        active = element[7] as string === "S" ? true : false

        // I. Sw Externo:
        if (element[8] as string != "S" && element[8] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna I. El campo Sw Externo debe ser valores como: S / N.`;
          this.transporterAlerts.push(alert);
          rowHasError = true;
        }
        swExternal = element[8] as string === "S" ? true : false

        if (!rowHasError) {
          row = new TransporterImportModel(counter, branchCode, name, typeDocumentId, documents, digitVerification, phone, alterPhone,
            active, swExternal);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorTransporter = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportTransporters(rowsImports);
    });
  }

  async processImportTransporters(rowsImports: Array<TransporterImportModel>) {
    try {
      const response = await firstValueFrom(this.transporterService.importTransporters(rowsImports));
      this.loadPreInvoicingModel = response;
      this.transporterAlerts = response?.alerts ?? [];
      this.errorTransporter = response?.preInvoicingStateId;

      if (this.errorTransporter === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.transporterAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.transporterImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Transportadores.', error);
    }
  }
}
